<template>
  <div class="empty-text">暂无数据</div>
</template>
<style lang="scss" scoped>
.empty-text {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
